import "core-js/modules/es6.regexp.to-string";
import _typeof from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/typeof.js";
import axios from 'axios';
import Vue from 'vue';
import router from '@/router/routers';
import { Notification, Loading, MessageBox } from 'element-ui';
import store from "../store";
import { getToken } from '@/utils/auth';
import _ from 'lodash';
import Config from '@/settings';
import Cookies from 'js-cookie';
var new_service = null;
var loadingInstance; //loading 实例
var needLoadingRequestCount = 0; //当前正在请求的数量

// 页面切换以后 去除遮罩层
router.beforeEach(function (to, from, next) {
  if (from.path !== to.path) {
    if (loadingInstance) {
      needLoadingRequestCount = 0;
      hideLoading();
    }
  }
  next();
});
function showLoading() {
  var main = document.querySelector('.show_contaniner'); //获取dom节点
  if (main) {
    if (needLoadingRequestCount === 0 && !loadingInstance) {
      loadingInstance = Loading.service({
        target: main,
        text: '正在加载...',
        background: 'rgba(0,0,0,0.1)',
        spinner: 'el-icon-loading'
      });
    }
    needLoadingRequestCount++;
  }
}
function closeLoading() {
  // 以服务的方式调用的 Loading 需要异步关闭
  needLoadingRequestCount--;
  needLoadingRequestCount = Math.max(needLoadingRequestCount, 0); // 保证大于等于0
  if (needLoadingRequestCount === 0) {
    if (loadingInstance) {
      hideLoading();
    }
  }
}
//防抖
var hideLoading = _.debounce(function () {
  loadingInstance.close();
  loadingInstance = null;
}, 10);
/**
 * @param type uploadFile:文件上传/ no-loading: 不启用loading
 *
 */
// 创建axios实例 process.env.VUE_APP_BASE_API
var service = function service(params) {
  new_service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    //baseURL: '/lockApi', // api 的 base_url
    timeout: Config.timeout // 请求超时时间
  });
  // request拦截器
  new_service.interceptors.request.use(function (config) {
    // request 第三个参数用来标识无需传token的情况，如文件上传
    if (getToken()) {
      config.headers['Authorization'] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    config.headers['Authorization'] = getToken();
    config.headers['Content-Type'] = 'application/json';
    // config.headers['Access-Control-Allow-Origin'] = '*'
    // config.headers['Access-Control-Allow-Headers'] = 'X-Requested-With,Content-Type'
    // config.headers['Access-Control-Allow-Methods'] = 'PUT,POST,GET,DELETE,OPTIONS'

    // if (type !== 'no-loading') {
    //     showLoading()
    // }
    showLoading();
    return config;
  }, function (error) {
    closeLoading();
    Promise.reject(error);
  });

  // response 拦截器
  new_service.interceptors.response.use(function (response) {
    new_service = null;
    closeLoading();
    if (response.data.code && response.data.code !== 200) {
      if (loadingInstance) {
        needLoadingRequestCount = 0;
        hideLoading();
      }
      if (response.data.code !== 510) {
        Notification.error({
          title: response.data.message,
          duration: 5000
        });
      }
    }
    return response.data;
  }, function (error) {
    if (loadingInstance) {
      needLoadingRequestCount = 0;
      hideLoading();
    }
    new_service = null;
    console.log(_typeof(error));
    // 兼容blob下载出错json提示
    if (error.response.data instanceof Blob && error.response.data.type.toLowerCase().indexOf('json') !== -1) {
      var reader = new FileReader();
      reader.readAsText(error.response.data, 'utf-8');
      reader.onload = function (e) {
        var errorMsg = JSON.parse(reader.result).message;
        Notification.error({
          title: errorMsg,
          duration: 5000
        });
      };
    } else {
      var code = 0;
      // console.log('error=>', error.response)
      try {
        code = error.response.data.status || error.response.data.code;
      } catch (e) {
        if (error.toString().indexOf('Error: timeout') !== -1) {
          Notification.error({
            title: '网络请求超时',
            duration: 5000
          });
          return Promise.reject(error);
        }
      }
      console.log(code);
      if (code) {
        if (code === 401) {
          store.dispatch('LogOut').then(function () {
            // 用户登录界面提示
            Cookies.set('point', 401);
            location.reload();
          });
        } else if (code === 403) {
          router.push({
            path: '/401'
          });
        } else if (code === 504) {
          Notification.error({
            title: '网络请求超时',
            duration: 5000
          });
          return Promise.reject(error);
        } else {
          var errorMsg = error.response.data.message;
          console.log('hhhhhhhaaa', error);
          if (errorMsg !== undefined) {
            Notification.error({
              title: errorMsg,
              duration: 5000
            });
          }
          Loading.service().close();
        }
      } else {
        var _errorMsg = error.response.data.message;
        Notification.error({
          title: _errorMsg,
          duration: 5000
        });
      }
    }
    return Promise.reject(error.response.data);
  });
  return new_service(params);
};
export default service;